import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import DiffusionItem from './DiffusionItem';

const DiffusionList = props => {
  const { users } = props;

  return (
    <div className="ui segment scrollContent">
      <div className="scroll">
        {users.length > 0 && (
          <table className="ui grey table">
            <thead>
              <tr>
                <th>Mail</th>
                <th>Nom</th>
                <th>Prénom</th>
              </tr>
            </thead>
            <tbody>
              {users.map(e => <DiffusionItem key={e.id} user={e} />)}
            </tbody>
          </table>
        )}
        {users.length === 0 && (
          <div className="ui icon message">
            <i className="circle info icon" />
            <div className="content">
              <div className="header">Aucun utilisateur sélectionné</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

DiffusionList.propTypes = {
  users: PropTypes.array.isRequired,
};

export default pure(DiffusionList);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/DiffusionList.js